import React, { useEffect, useState } from "react";
import axios from "axios";

import {
  Table,
  Button,
  TextInput,
  Modal,
  MantineProvider,
  Switch,
} from "@mantine/core";
import { Calendar } from "@mantine/dates";
import COM_Upload_IMG_v2 from "../Component/COM_Upload_IMG_v2";

const { REACT_APP_ECLIPSE_API } = process.env;

const Comp_CareU_Buffet = ({ selectedCafe }) => {
  console.log("selectedCafe", selectedCafe);

  const [DB_BuffetScheduleList, setDB_BuffetScheduleList] = useState([]);
  const get_DB_BuffetSchedule = () => {
    axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/get_eclipse_careu__cafe_buffet_schedule__all`
      )
      .then((res) => {
        // setBD_CafeHardware(res.data);
        let result = res?.data?.filter((x) => {
          return x?.cafe_name === selectedCafe;
        })?.[0];

        console.log("get_DB_BuffetSchedule result", result);
        setDB_BuffetScheduleList(result);
      });
  };

  const set_DB_BuffetSchedule_ByAttNameAndValue = (id, attName, attValue) => {
    if (isValid([id, attName, attValue]) === false) {
      alert("Please fill all fields correctly.");
      return;
    }

    if (isOnlyNumbersAndColons(attValue) === false) {
      alert("Please enter a valid time format (HH:MM:SS).");
      return;
    }

    axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/set_eclipse_careu__cafe_buffet_schedule__status`,
        {
          id,
          attName,
          attValue,
        }
      )
      .then((res) => {
        console.log(
          "set_DB_BuffetSchedule_ByAttNameAndValue result",
          res?.data
        );
        if (isMysqlSuccess(res?.data)) {
          alert("Update successful!");
        } else {
          alert("Update failed. Please try again.");
        }
        get_DB_BuffetSchedule();
      });
    setSelectedTextValue("");
    setReRenderKey((prev) => prev + 1);
  };

  // ------------------------------------------------- global variables
  const [apiFolderName, setApiFolderName] = useState("");
  const [apiFileCafeName, setApiFileCafeName] = useState("");

  const [selectedTextValue, setSelectedTextValue] = useState("");

  const [reRednerKey, setReRenderKey] = useState(0);

  // ------------------------------------------------- functions
  const isValid = (arr) =>
    arr.every((v) => v !== null && v !== "" && v !== undefined);

  const isOnlyNumbersAndColons = (str) => {
    return typeof str === "string" && /^[0-9:]+$/.test(str);
  };

  const isMysqlSuccess = (response) => {
    return (
      response &&
      typeof response === "object" &&
      ("affectedRows" in response || "changedRows" in response) &&
      (response.affectedRows > 0 || response.changedRows > 0)
    );
  };

  // ------------------------------------------------- component
  const LiveNowIndicator = ({ start = "08:00:00", end = "11:00:00" }) => {
    const isNowBetweenTimes = (startTimeStr, endTimeStr) => {
      const now = new Date();

      const [startH, startM, startS] = startTimeStr.split(":").map(Number);
      const [endH, endM, endS] = endTimeStr.split(":").map(Number);

      const start = new Date(now);
      start.setHours(startH, startM, startS, 0);

      const end = new Date(now);
      end.setHours(endH, endM, endS, 0);

      // Handle cross-midnight
      if (start > end) {
        // e.g., start = 22:00:00, end = 02:00:00
        // Two cases:
        // - now >= start today
        // - or now <= end (next day)
        return now >= start || now <= end;
      } else {
        return now >= start && now <= end;
      }
    };

    const isLive = isNowBetweenTimes(start, end);

    return (
      <div style={{ color: isLive ? "lime" : "red", fontWeight: "bold" }}>
        {isLive ? "Live Now" : "Waiting..."}
      </div>
    );
  };

  //   useEffect(() => {}, []);

  useEffect(() => {
    get_DB_BuffetSchedule();
    setApiFolderName(selectedCafe?.split(" ")?.[0]?.toLowerCase());
    setApiFileCafeName(selectedCafe?.replaceAll(" ", "_"));
  }, [selectedCafe]);
  return (
    <div>
      <div>{`Selected Cafe : ${selectedCafe}`}</div>
      <div>{`apiFolderName : ${apiFolderName}`}</div>
      <div>{`apiFileCafeName : ${apiFileCafeName}`}</div>

      <div className="CU_FlexRow">
        <h2>{selectedCafe}</h2>
        <Button
          size="xl"
          variant="filled"
          color="dark"
          onClick={() => {
            window.open(
              `http://localhost:7000/ccadv?cafe_name=${selectedCafe}&pc_name=pc001`,
              "_b"
            );
          }}
        >
          🔍Local View
        </Button>
        <Button
          size="xl"
          variant="filled"
          color="dark"
          onClick={() => {
            window.open(
              `https://eclipsemy.com/ccadv?cafe_name=${selectedCafe}&pc_name=pc001`,
              "_b"
            );
          }}
        >
          🔍Live View
        </Button>
      </div>
      <div className="CU_FlexRow">
        {["1", "2", "3", "4", "5", "6"]?.map((x, xi) => {
          return (
            <div
              style={{
                backgroundColor: "black",
                margin: "0.2rem",
                padding: "0.2rem",

                borderRadius: "0.3rem",
              }}
            >
              <COM_Upload_IMG_v2
                COM_Label={`${selectedCafe}, Buffet ${xi + 1}`}
                sto_DirPath={`./uploads/Eclipse_CareU/img/${apiFolderName}/`}
                sto_FileName={`${apiFileCafeName}_buffet_${xi + 1}.jpg`}
                COM_Width="15rem"
                COM_Height="20rem"
                COM_fontsize=".5rem"
              />
              <br />
              <br />
              <div className="CU_Grid_1fr1ft">
                <div>{`Buffet ${xi + 1}`}</div>
                <LiveNowIndicator
                  start={DB_BuffetScheduleList?.[`buffet_${xi + 1}_start`]}
                  end={DB_BuffetScheduleList?.[`buffet_${xi + 1}_end`]}
                />
              </div>
              <div className="CU_Grid_1fr1ft">
                <div>Start :</div>

                <div>
                  {`${DB_BuffetScheduleList?.[`buffet_${xi + 1}_start`]}`}
                </div>

                <div>End :</div>
                <div>
                  {`${DB_BuffetScheduleList?.[`buffet_${xi + 1}_end`]}`}
                </div>
                <div>Enabled :</div>
                <div
                  style={{
                    color:
                      DB_BuffetScheduleList?.[`buffet_${xi + 1}_on`] == "1"
                        ? "lime"
                        : "red",
                    fontWeight: "bold",
                  }}
                  className="CU_FlexRow"
                >
                  {`${DB_BuffetScheduleList?.[`buffet_${xi + 1}_on`]}` == "1"
                    ? "ON"
                    : "OFF"}
                  <Switch
                    checked={
                      `${DB_BuffetScheduleList?.[`buffet_${xi + 1}_on`]}` == "1"
                        ? true
                        : false
                    }
                    onChange={(event) => {
                      console.log(event.currentTarget.checked);

                      set_DB_BuffetSchedule_ByAttNameAndValue(
                        DB_BuffetScheduleList?.id?.toString()?.trim(),
                        `buffet_${xi + 1}_on`?.toString()?.trim(),
                        event.currentTarget.checked ? "1" : "0"
                      );
                    }}
                  />
                </div>
              </div>
              <div
                // style={{ marginRight: "1rem" }}
                className="CU_FlexRow CU_AlignItem_FlexEnd"
              >
                <TextInput
                  key={reRednerKey}
                  label=""
                  w="100%"
                  placeholder={`${
                    DB_BuffetScheduleList?.[`buffet_${xi + 1}_start`]
                  }`}
                  onChange={(event) => {
                    setSelectedTextValue(event.currentTarget.value);
                    console.log("sss", event.currentTarget.value);
                  }}
                />
                <Button
                  color="red"
                  variant="outline"
                  onClick={() => {
                    set_DB_BuffetSchedule_ByAttNameAndValue(
                      DB_BuffetScheduleList?.id?.toString()?.trim(),
                      `buffet_${xi + 1}_start`?.toString()?.trim(),
                      selectedTextValue?.toString()?.trim()
                    );
                  }}
                >
                  Update Start
                </Button>
              </div>
              <div
                // style={{ marginRight: "1rem" }}
                className="CU_FlexRow CU_AlignItem_FlexEnd"
              >
                <TextInput
                  key={reRednerKey}
                  label=""
                  w="100%"
                  placeholder={`${
                    DB_BuffetScheduleList?.[`buffet_${xi + 1}_end`]
                  }`}
                  onChange={(event) => {
                    setSelectedTextValue(event.currentTarget.value);
                    console.log("sss", event.currentTarget.value);
                  }}
                />
                <Button
                  color="red"
                  variant="outline"
                  onClick={() => {
                    set_DB_BuffetSchedule_ByAttNameAndValue(
                      DB_BuffetScheduleList?.id?.toString()?.trim(),
                      `buffet_${xi + 1}_end`?.toString()?.trim(),
                      selectedTextValue?.toString()?.trim()
                    );
                  }}
                >
                  Update End
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Comp_CareU_Buffet;
